import Vue from 'vue';
import ocrmultiselect from './components/ocr-multiselect';

import(
    /* webpackMode: "lazy-once" */
    `../../../entrypoints/translations/sat-translations.js`
).then(function () {
    new Vue({
        name: 'OCRMultiselectRoot',
        el: '#MultipleLanguagesSelector',
        components: { ocrmultiselect },
        render(h) {
            return h(ocrmultiselect);
        },
    });
});
